import { Box } from "@mui/material";
import { SearchWithResult, SearchResultsPanel, SearchResultItem } from "@react-admin/ra-search";
import { useSolarSidebarActiveMenu } from "@react-admin/ra-navigation";
import { ClientListItem } from "./SearchItems/ClientListItem";
import { PolicyListItem } from "./SearchItems/PolicyListItem";
import { ClaimantListItem } from "./SearchItems";
import { ResourceName } from "@/types";

export const SearchSubMenu = () => {
  const [, setActiveMenu] = useSolarSidebarActiveMenu();
  const handleClose = () => {
    setActiveMenu("");
  };
  return (
    <Box data-testid="search" m={-1} width={{ xs: "100%", md: 270 }}>
      <SearchWithResult onNavigate={handleClose} sx={{ m: 1 }}>
        <SearchResultsPanel
          sx={{
            maxHeight: "calc(100vh - 65px)",
            overflowX: "hidden",
            marginBlockEnd: 0,
            px: 1,
          }}
          disablePadding
          data-testid="search-panel"
        >
          <CustomSearchResultItem />
        </SearchResultsPanel>
      </SearchWithResult>
    </Box>
  );
};

const CustomSearchResultItem = (props: any) => {
  const { data, onClose, ...rest } = props;

  if (!data) {
    return null;
  }

  switch (data.type) {
    case ResourceName.CLIENTS:
      return <ClientListItem {...rest} data={data} onClick={onClose} />;
    case ResourceName.POLICIES:
      return <PolicyListItem {...rest} data={data} onClick={onClose} />;
    case ResourceName.CLAIMANTS:
      return <ClaimantListItem {...rest} data={data} onClick={onClose} />;
    default:
      return <SearchResultItem {...props} />;
  }
};
